import { useI18n } from '#imports'

export const useTranslator = () => {
  const { t } = useI18n()
  const translate = (key: string, namedValue?: { [key: string]: string }) => {
    if (namedValue) {
      return t('epp.' + key, namedValue)
    }
    return t('epp.' + key)
  }

  return {
    translate
  }
}